import {
  FGGridContainer,
  FGGridItem,
  FGMediaObject,
  FGTypography,
  FGLink,
  FGMediaObjectFigure,
  FGMediaObjectBody,
} from '@fg/design-system';

export const CSInquiries = () => {
  return (
    <>
      <FGGridContainer
        xxs={1}
        sm={3}
        style={{
          margin: '64px auto',
        }}
      >
        <FGGridItem classNames="fg-ta--c">
          <FGTypography tag="h6" style="headline5">
            Sales
          </FGTypography>
          <FGLink href={`mailto:subscriptions@creditsights.com`} appearance="blue">
            subscriptions@creditsights.com
          </FGLink>
        </FGGridItem>
        <FGGridItem classNames="fg-ta--c">
          <FGTypography tag="h6" style="headline5">
            Media Contacts
          </FGTypography>
          <FGLink href={`mailto:media@creditsights.com`} appearance="blue">
            media@creditsights.com
          </FGLink>
        </FGGridItem>
        <FGGridItem classNames="fg-ta--c">
          <FGTypography tag="h6" style="headline5">
            Technical Assistance
          </FGTypography>
          <FGLink href={`mailto:help@creditsights.com`} appearance="blue">
            help@creditsights.com
          </FGLink>
        </FGGridItem>
      </FGGridContainer>

      <div
        style={{
          padding: '32px 32px',
          maxWidth: '1300px',
          margin: '64px auto',
          border: '1px solid rgba(0, 0, 0, 0.12)',
          borderRadius: '3px',
        }}
      >
        <FGGridContainer xxs={1} xs={2} sm={4}>
          <FGGridItem>
            <FGMediaObject alignment="center" classNames="fg-pd--y8">
              <FGMediaObjectFigure>
                <img src="/resources/img/newyork.jpg" alt="" width="115" className="fg-bd--rs-small" />
              </FGMediaObjectFigure>
              <FGMediaObjectBody>
                <div className="fg-ta--c">
                  <FGTypography tag="h6" style="headline6">
                    New York
                  </FGTypography>
                  <div className="fg-mg--y2">
                    <FGTypography tag="p" style="body3-short">
                      +1 (212) 340-3840
                    </FGTypography>
                  </div>
                  <div>
                    <FGTypography tag="p" style="body3-short">
                      2 Park Avenue, 24th Floor
                      <br />
                      New York, NY 10016
                    </FGTypography>
                  </div>
                </div>
              </FGMediaObjectBody>
            </FGMediaObject>
          </FGGridItem>
          <FGGridItem>
            <FGMediaObject alignment="center" classNames="fg-pd--y8">
              <FGMediaObjectFigure>
                <img src="/resources/img/london.jpg" alt="" width="115" className="fg-bd--rs-small" />
              </FGMediaObjectFigure>
              <FGMediaObjectBody>
                <div className="fg-ta--c">
                  <FGTypography tag="h6" style="headline6">
                    London
                  </FGTypography>
                  <div className="fg-mg--y2">
                    <FGTypography tag="p" style="body3-short">
                      +44 (0)20 7429 2080
                    </FGTypography>
                  </div>
                  <div>
                    <FGTypography tag="p" style="body3-short">
                      30 North Colonnade Canary Wharf
                      <br />
                      London, E14 5GN
                    </FGTypography>
                  </div>
                </div>
              </FGMediaObjectBody>
            </FGMediaObject>
          </FGGridItem>
          <FGGridItem>
            <FGMediaObject alignment="center" classNames="fg-pd--y8">
              <FGMediaObjectFigure>
                <img src="/resources/img/denver.jpg" alt="" width="115" className="fg-bd--rs-small" />
              </FGMediaObjectFigure>
              <FGMediaObjectBody>
                <div className="fg-ta--c">
                  <FGTypography tag="h6" style="headline6">
                    Denver
                  </FGTypography>
                  <div className="fg-mg--y2">
                    <FGTypography tag="p" style="body3-short">
                      +1 (212) 340-3840
                    </FGTypography>
                  </div>
                  <div>
                    <FGTypography tag="p" style="body3-short">
                      1553 Platte Street, Suite 208
                      <br />
                      Denver, CO 80202-5197
                    </FGTypography>
                  </div>
                </div>
              </FGMediaObjectBody>
            </FGMediaObject>
          </FGGridItem>
          <FGGridItem>
            <FGMediaObject alignment="center" classNames="fg-pd--y8">
              <FGMediaObjectFigure>
                <img src="/resources/img/singapore.jpg" alt="" width="115" className="fg-bd--rs-small" />
              </FGMediaObjectFigure>
              <FGMediaObjectBody>
                <div className="fg-ta--c">
                  <FGTypography tag="h6" style="headline6">
                    Singapore
                  </FGTypography>
                  <div className="fg-mg--y2">
                    <FGTypography tag="p" style="body3-short">
                      +65 6990 5600
                    </FGTypography>
                  </div>
                  <div>
                    <FGTypography tag="p" style="body3-short">
                      8 Marina View Asia Square Tower 1<br />
                      Level 43 Singapore 018960
                    </FGTypography>
                  </div>
                </div>
              </FGMediaObjectBody>
            </FGMediaObject>
          </FGGridItem>
        </FGGridContainer>
      </div>
    </>
  );
};
